import React from "react";

import { Spinner, Text } from "@performyard/py-components";

import pluralizer from "../../../../utils/pluralizer";

type ImportProgressProps = {
	/** Employees written so far — the write loop's unit. */
	progressCount: number;
	progressTotal: number;
};

// Deliberately identical to the validating state in ValidationResults: the two are the same kind of
// wait, so they read as one thing rather than two differently-shaped panels.
const ImportProgress = ({ progressCount, progressTotal }: ImportProgressProps) => {
	// The total isn't known until the server has re-checked the file.
	const hasTotal = progressTotal > 0 && progressCount <= progressTotal;

	return (
		<section aria-label="Import progress" className="flex items-center gap-3">
			<Spinner size={20} />
			<Text size="paragraph-3" weight="regular" color="neutral-7">
				{hasTotal
					? `Importing entries for ${progressCount} of ${progressTotal} ${pluralizer(progressTotal, "employee", "employees")}…`
					: "Importing entries…"}
			</Text>
		</section>
	);
};

export default ImportProgress;
